import React, { useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import PageShell from "../components/PageShell";
import { useDemoBooking } from "../components/DemoBookingDialog";
import Hero from "../sections/Hero";
import LetterField from "../components/LetterField";
import products from "../data/products";
import { localizedPath } from "../i18n/locales";
import { useLocale } from "../i18n/useLocale";

const HASH_ROUTES = {
  about: "/about",
  products: "/solutions",
  solutions: "/solutions",
  contact: "/contact",
};

const Home = () => {
  const { hash } = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { locale, path } = useLocale();
  const { openBooking } = useDemoBooking();

  useEffect(() => {
    const id = hash.replace("#", "");
    const next = HASH_ROUTES[id];
    if (next) navigate(localizedPath(locale, next), { replace: true });
  }, [hash, navigate, locale]);

  return (
    <PageShell>
      <Hero />
      <section id="work" className="index">
        <div className="wrap index-layout">
          <h2>{t("home.workTitle")}</h2>
          <div>
            <ul className="work-list">
              {products.map((product) => (
                <li key={product.id}>
                  <Link to={path("/solutions")}>
                    <span className="work-kind">{t(`products.items.${product.id}.kind`)}</span>
                    <span>{t(`products.items.${product.id}.tab`)}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>
      <section className="closing">
        <LetterField />
        <div className="wrap closing-copy">
          <h2>
            {t("home.ctaBefore")}
            <em>{t("home.ctaHighlight")}</em>
            {t("home.ctaAfter")}
          </h2>
          <button type="button" className="btn-pill" onClick={openBooking}>
            {t("home.ctaButton")}
          </button>
        </div>
      </section>
    </PageShell>
  );
};

export default Home;
